module.exports = __webpack_public_path__ + "static/img/role.9f6ce32.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/role3/bz/role.png
// module id = Blgy
// module chunks = 7